import { List, Checkbox, Box, Group, Button, Text } from '@mantine/core';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface ValidateBatchFormProps {
  name: string;
  campaign: string;
  tonnage: number;
  area: number;
  lot_engaged_fields_stats: {
    count: number;
    total_area: number;
  };
  error?: boolean;
  onConfirmBatch: () => void;
  onCancel: () => void;
}

export const ValidateBatchForm: FC<ValidateBatchFormProps> = ({
  name,
  campaign,
  tonnage,
  area,
  lot_engaged_fields_stats,
  error = false,
  onConfirmBatch,
  onCancel,
}) => {
  const { t } = useTranslation();
  const [confirmBatchForm, setConfirmBatchForm] = useState(false);

  const handleConfirmBatch = () => {
    if (confirmBatchForm) {
      onConfirmBatch();
    }
  };

  return (
    <div>
      <Text fw="bold" mt="md" size="lg">
        {t('common.batch')} : {name}
      </Text>
      <List>
        <List.Item>
          {t('common.annee-de-recolte')} : {campaign}
        </List.Item>
        <List.Item>
          {t('common.tonnage')} : {tonnage} t
        </List.Item>
        <List.Item>
          {t('common.superficie-totale')} : {area.toFixed(2)} ha
        </List.Item>
      </List>

      <Text fw="bold" mt="md" size="lg">
        {t('common.parcelles-declarees')}
      </Text>
      <List>
        <List.Item>
          {t('common.nombre-de-parcelles')} : {lot_engaged_fields_stats.count}
        </List.Item>
        <List.Item>
          {t('common.area')} : {lot_engaged_fields_stats.total_area.toFixed(2)}{' '}
          ha
        </List.Item>
      </List>

      <Checkbox
        checked={confirmBatchForm}
        label={<Text size="md">{t('contracts.confirm-batch-check')}</Text>}
        mt="md"
        onChange={(e) => setConfirmBatchForm(e.currentTarget.checked)}
      />

      <Box mt="md">
        {error ? (
          <Text c="red">{t('contracts.confirm-batch-error')}</Text>
        ) : null}
        <Group>
          <Button
            disabled={!confirmBatchForm}
            onClick={handleConfirmBatch}
            type="submit"
          >
            {t('common.confirm')}
          </Button>
          <Button color="red" onClick={onCancel}>
            {t('common.cancel')}
          </Button>
        </Group>
      </Box>
    </div>
  );
};
